// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-badge[data-v-c88266dc]  .v-badge__badge{padding:3px}.small[data-v-c88266dc]  .v-badge__badge{font-size:7px!important;height:16px;padding:1px}.small[data-v-c88266dc]  .v-badge__badge .v-icon{font-size:10px}", ""]);
// Exports
module.exports = exports;
